import { caseDetailHref, kycRegistryHref } from '../MemberCompliancePanels'

export function buildNeedsAttention({
  profileData,
  caseHistory = [],
  kycEntries = [],
  amlChecks = [],
  ocrNameMismatch,
  sowStatus,
}) {
  const items = []
  const memberKey = profileData?.MembershipNumber || profileData?.MID

  const openCases = (caseHistory || []).filter((c) => {
    const s = String(c.status || '').toLowerCase()
    return s !== 'closed' && s !== 'filed' && s !== 'resolved'
  })
  for (const c of openCases.slice(0, 3)) {
    const href = caseDetailHref(c)
    items.push({
      id: `case-${c.id}`,
      label: `Investigation ${c.case_number || c.id}`,
      actionLabel: 'Open',
      section: 'timeline',
      href,
    })
  }

  const dvs = String(profileData?.DVSStatus || '').toUpperCase()
  if (dvs === 'FAILED' || dvs === 'REJECTED') {
    const latestKyc = kycEntries[0]
    items.push({
      id: 'dvs-failed',
      label: 'DVS / identity verification failed',
      actionLabel: 'Re-verify',
      section: 'identity',
      href: latestKyc?.id ? kycRegistryHref(memberKey, latestKyc.id) : null,
    })
  }

  const confirmedAml = (amlChecks || []).find((c) => c.analyst_decision === 'confirmed_match')
  const pendingAml = (amlChecks || []).find(
    (c) => Number(c.result_count) > 0 && c.analyst_decision !== 'no_match' && c.analyst_decision !== 'confirmed_match'
  )
  const materialAml = confirmedAml || pendingAml
  if (materialAml) {
    items.push({
      id: `aml-${materialAml.id}`,
      label: confirmedAml ? 'Confirmed screening match on file' : 'Screening results need review',
      actionLabel: 'Review',
      section: 'screening',
      amlCheckId: materialAml.id,
    })
  }

  if (ocrNameMismatch) {
    items.push({
      id: 'ocr-mismatch',
      label: 'Document name does not match profile',
      actionLabel: 'Review',
      section: 'identity',
    })
  }

  if (sowStatus === 'missing' || sowStatus === 'none') {
    items.push({
      id: 'sow-missing',
      label: 'No source of wealth on file',
      actionLabel: 'Request',
      section: 'declarations',
    })
  }

  return items.slice(0, 6)
}
